<template>
  <div class="page-content" style="margin: 0px; width: 100%;">
    <v-container class="subprimary">
      <v-layout justify-start row>
        <h1>{{mainpage.title}}</h1>
        <vue-headful
          :description=mainpage.title
          :title=mainpage.title
        />
      </v-layout>
      <v-divider></v-divider>
      <v-layout justify-start row>
        <breadcrumbs style="padding-top: 6px"></breadcrumbs>
      </v-layout>
    </v-container>
<!--    <ApplicationDiss v-if="$route.name === 'DissBreadcrumbs'"></ApplicationDiss>-->
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import ApplicationDiss from './ApplicationDiss'
  import urls from "../urls";
  import UserDataMixin from "../../../mixins/UserDataMixin";
  import {makeGetRequest,isAuthenticated} from "../../../helper";

  export default {
    name: "PetitionBreadcrumbs",
    components: {ApplicationDiss},
    mixins: [UserDataMixin],
    data: function () {
      return {
          local_admin: null,
      }
    },
    computed: mapState({
      mainpage: state => state.mainpage,
    }),
    methods: {

      allowed(urlname, action) {
        return urls.getUrlAllowed(urlname, action)
      },

    },
    created() {

        if (!this.allowed('admin|petition|petition|petition_create_council-list', 'list') && !this.allowed('admin|petition|petition|petition_create_permanent_council-list', 'list')){
            alert("У вас нет прав на просмотр страницы");
            this.$router.push({name: 'Tools'});
        }

        if(isAuthenticated()){
            this.$store.commit('leftmenu/enableLeftMenu');
        }else {
            this.$store.commit('leftmenu/dissable');
        }
      this.$store.commit('leftmenu/selectInstance', 'petition');//ListUsers
      this.$store.commit('mainpage/changeTitle', 'Ходатайство о подачи заявки на создание диссертационного совета');
      let menu = [
        {title: 'Списки заявлений', icon: 'contact_mail', router: 'ListDiss',},

      ];
        if (this.allowed('admin|petition|petition|petition_create_council-list', 'list')){
            menu.push({title: 'Подать ходатайство', icon: 'import_export', router: 'ApplicationDiss',})
        }
        if (this.allowed('admin|petition|petition|petition_create_permanent_council-list', 'list')){
            menu.push({title: 'Подать на создание', icon: 'sync_alt', router: 'Council',})
        }

      this.$store.commit('leftmenu/replaceItems', menu);
      let instances = [
          {title: 'Диссертационные дела', icon: 'date_range', router: 'OpenDiss', name: 'diss',},
        {title: 'Диссертационные советы', icon: 'calendar_today', router: 'PetitionBreadcrumbs', name: 'petition',},
      ];
      this.$store.commit('leftmenu/replaceInstances', instances);
    },


  }
</script>

<style scoped>


</style>
